module.exports = __webpack_public_path__ + "static/img/supplyChain.d579754a.svg";